<template>
  <el-collapse class="coll-wrap" v-model="activeNames" accordion>
    <div v-for="(item, i) in dataList" :key="i" style="width: 90%;margin-left: 5%;border-bottom: 1px solid #EBEEF5;">
      <el-collapse-item
        v-if="item.children && item.children.length && item.label != '业务领域' && item.label != '专业人员'"
        :title="item.label"
        :name="item.label"
        style="font-size: 18px;font-weight: 500;color: #7F7F7F;"
        >
        <asideBarItem :routerFun="router" :choseId="choseId" v-if="item.children.length" :dataList="item.children" />
      </el-collapse-item>
      <div @click="toPhonePage(item)" class="item" :style="{'font-size':'18px','font-weight':'500',padding:'13px 0',color:item.label+item.id != choseId? '#7F7F7F':'#AA1100'}" v-else>{{ item.label }}</div>
    </div>
  </el-collapse>
</template>

<script>
	import {queryByPos,queryIndexByPos} from "../../api/front.js"
  export default {
    name: "asideBarItem",
    props: {
      dataList: {
        type: Array,
        default: () => [],
      },
      choseId:{
        type: String,
        default: () => '首页0',
      },
      activeNames:{
        type: String,
        default: () => '首页',
      },
      routerFun:{
        type: Function,
        default: null
      }
    },
    data() {
      return {
      };
    },
		mounted() {
      console.log(this.dataList)
			// queryIndexByPos('nav').then(data => {
			// 	this.channels = this.channels.concat(data.data)
			// 	console.log("导航栏",this.channels)
			// }).catch(error => {

			// })
		},
    methods:{
      router(url){
        this.routerFun(url)
      },
      toPhonePage(item){
        let page = item.label+item.id;
        console.log(page)
        let url = '/phoneIndex'
        if(page != this.choseId){
          if(page == '首页0'){
            this.routerFun('/phoneIndex')
          }else if(page == '律所简介29'){
            this.routerFun('/phoneAboutUs')
          }else if(page == '发展历程30'){
            this.routerFun('/phoneDevelopmentHistory')
          }else if(page == '荣誉奖项31'){
            this.routerFun('/phoneHonoraryAwards')
          }else if(page == '红色建设32'){
            this.routerFun('/phoneRedConstruction')
          }else if(page == '和华文化24'){
            this.routerFun('/phoneHehuaCulture')
          }else if(page == '业务领域25'){
            this.routerFun('/phoneBusinessArea')
          }
          else if(page == '专业人员26'){
            this.routerFun('/phoneProfessional')
          }else if(page == '专业人员26'){
            this.routerFun('/phoneProfessional')
          }else if(page == '新闻资讯13'){
            this.routerFun('/phoneNews')
          }else if(page == '经典案例14'){
            this.routerFun('/phoneClassicCases')
          }else if(page == '专业文章15'){
            this.routerFun('/phoneProfessionalArticles')
          }else if(page == '联系我们33'){
            this.routerFun('/phoneContactUs')
          }else if(page == '加入我们34'){
            this.routerFun('/phoneJoinUs')
          }
        }
      },
    }
  };
</script>

<style scoped>
  .coll-wrap /deep/ .el-collapse-item__content {
    padding-bottom: 0 !important;
  }
  .coll-wrap /deep/ .el-collapse-item__wrap {
    border: 0 !important;
  }
  .item{
    padding: 15px 0;
  }
  .coll-wrap /deep/ .el-collapse-item__header {
    font-size: 18px !important;
    font-weight: 500 !important;
    color: #7F7F7F !important;
  }
</style>

